import { $mount } from '../../../js/dom-lifecycle';

$mount('body.page-login form').on('submit', function () {
    $(this).find('button[type="submit"]').attr('disabled', 'disabled');
});
